window.$ = window.jQuery = require("jquery");

// LazyLoad - https://github.com/aFarkas/lazysizes
import "lazysizes";
// import a plugin
import "lazysizes/plugins/parent-fit/ls.parent-fit";
import AOS from 'aos';


// GSAP
// import {
//     gsap,
//     ScrollTrigger
// } from "gsap/all";
// import {
//     DrawSVGPlugin
// } from "gsap/DrawSVGPlugin";
// gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);

// import Swiper bundle with all modules installed
// import Swiper from 'swiper/bundle';

// Theme Functions
const fSmoothScroll = require("./utils/smooth-scroll");
const fSwiper = require("./components/swiper");
const fAccordion = require("./components/accordion");

// Vue Support Function
import { createApp, defineAsyncComponent } from "vue";
import VueGoogleMaps from "@fawmi/vue-google-maps";

const InitVueComponents = () => {

    if (document.getElementById("vue-space-plan")) {
        const Plan = defineAsyncComponent(() => import("./vue/plan"));
        const $loadComponent = createApp({});
        $loadComponent.component("plan", Plan);

        $loadComponent.mount("#vue-space-plan");
    }

    if (document.getElementById("vue-space-building-plan")) {
        const BuildingPlan = defineAsyncComponent(() => import("./vue/building-plan"));
        const $loadComponent = createApp({});
        $loadComponent.component("building-plan", BuildingPlan);

        $loadComponent.mount("#vue-space-building-plan");
    }

    if (document.getElementById("vue-space-map")) {
        const Map = defineAsyncComponent(() => import("./vue/google-map"));
        const $loadComponent = createApp({});
        $loadComponent.use(VueGoogleMaps, {
            load: {
                key: "AIzaSyAYYTvp-gUd31qA4TfLGpcFRk4kFhnPRQY",
            },
        });
        $loadComponent.component("google-map", Map);

        $loadComponent.mount("#vue-space-map");
    }

    if (document.getElementById("vue-space-footer-popup")) {
        const FooterPopup = defineAsyncComponent(() => import("./vue/footer-popup"));
        const $loadComponent = createApp({});
        $loadComponent
            .component("footer-popup", FooterPopup);


        $loadComponent.mount('#vue-space-footer-popup');
    }
};

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    fSmoothScroll();
    fSwiper.init();
    fAccordion.init();
    AOS.init({
        once: true,
        offset: -100,
        easing: 'ease-in',
        duration: 800,
        delay: 500,

    });

    InitVueComponents();

    // Scroll back to top of a page
    let backToTopBtn = document.querySelector(".back-to-top-btn");

    if (backToTopBtn) {
        backToTopBtn.addEventListener("click", scrollToTop);
    }

    function scrollToTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    // Dropdown menu
    const header = document.querySelector(".header");
    const headerGhost = document.querySelector(".header-ghost");
    
    function scrollUpdate() {
        if ( window.scrollY > 0 ) {
            headerGhost.style.height = `${header.clientHeight}px`;
            header.classList.add("fixed");
            header.classList.remove("sticky");
        }
        else {
            headerGhost.style.height = null;
            header.classList.add("sticky");
            header.classList.remove("fixed");
        }
    }
    
    scrollUpdate();
    window.addEventListener("scroll", scrollUpdate)

    document.querySelector(".burger-menu").addEventListener("click", toggleMobileMenu);
    let menu = document.querySelector(".menu-wrapper");
    
    const subMenus = document.querySelectorAll(".menu-item-has-children");
    subMenus.forEach(subMenu => {
        subMenu.querySelector("a").addEventListener("mouseover", openMenu);
        
        subMenu.querySelector("a").addEventListener("click", (e) => {
            if ( e.pointerType === "touch" && !isOpenMenu ) {
                e.preventDefault();
            }
        });
    })
    
    menu.addEventListener("mouseleave", () => {
        if ( isOpenMenu ) closeMenu();
    })

    let isOpenMenu = false;
    
    function openMenu() {
        menu.classList.add("active");
        header.classList.add("md:drop-shadow-none");
        document.body.classList.add('body-no-scroll');
        
        isOpenMenu = true;
    }

    function closeMenu() {
        menu.classList.remove("active");
        header.classList.remove("md:drop-shadow-none");
        document.body.classList.remove('body-no-scroll')
        
        isOpenMenu = false;
    }
    
    function toggleMobileMenu() {
        if ( isOpenMenu ) {
            closeMenu();
        }
        else {
            openMenu();
        }
    }

    // Two color divs
    let topDiv = document.querySelector(".cta-top-div");
    let bottomDiv = document.querySelector(".cta-bottom-div");
    let topArrow = document.querySelector(".cta-top-div-arrow");
    let bottomArrow = document.querySelector(".cta-bottom-div-arrow");
    let firstImage = document.querySelector(".cta-first-image");

    if (bottomDiv && topDiv) {
        bottomDiv.addEventListener("mouseenter", (event) => {
            topDiv.classList.remove("md:bg-turquoise");
            bottomDiv.classList.remove("bg-white");
            bottomDiv.classList.add("md:bg-turquoise");
            topArrow.classList.remove("md:opacity-100");
            bottomArrow.classList.add("md:opacity-100");
            firstImage.classList.remove("z-20");
        });
    }
    if (bottomDiv && topDiv) {
        bottomDiv.addEventListener("mouseleave", (event) => {
            bottomDiv.classList.remove("md:bg-turquoise");
            bottomDiv.classList.add("bg-white");
            topDiv.classList.add("md:bg-turquoise");
            topArrow.classList.add("md:opacity-100");
            bottomArrow.classList.remove("md:opacity-100");
            firstImage.classList.add("z-20");
        });
    }

    // Accordion
    const accordionTitles = document.querySelectorAll(".accordion");

    accordionTitles.forEach((accordionTitle) => {
        accordionTitle.addEventListener("click", () => {
            if (accordionTitle.classList.contains("is-open")) {
                accordionTitle.classList.remove("is-open");
            } else {
                const accordionTitlesWithIsOpen =
                    document.querySelectorAll(".is-open");
                accordionTitlesWithIsOpen.forEach(
                    (accordionTitleWithIsOpen) => {
                        accordionTitleWithIsOpen.classList.remove("is-open");
                    }
                );
                accordionTitle.classList.add("is-open");
            }
        });
    });

    //Hide desktop submenu 
    window.addEventListener('click', function (e) {
        if (!document.querySelector('.menu-wrapper').contains(e.target) && menu.classList.contains('active')) {
            toggleMobileMenu();

        }
    });
    const menuItems = document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"])');
    for (const link of menuItems) {
        link.addEventListener("click", handleSubmenuClick);
    }
    function handleSubmenuClick() {
        if (menu.classList.contains('active')) {
            toggleMobileMenu();

        }

    }
});

